import { createSlice } from '@reduxjs/toolkit';

import { initEdf, reset } from './loadingFiles';
import { buildRecStartDateTimeISO } from './helpers';

const initialState = {};
Object.freeze(initialState);

const headersSlice = createSlice({
    name: 'edfHeaders',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initEdf, (state, { payload: { headers } }) => {
                Object.assign(state, headers, {
                    recStartDateTimeISO: buildRecStartDateTimeISO(headers),
                });
            })
            .addCase(reset, () => initialState);
    },
});

export default headersSlice.reducer;
